import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {BlackListRequest, BlackListResponse, BlackListStateModel} from './models';
import {deleteBlackList, exportData, fetchBlackListRows} from './operations';


const initialState = {
  data: {} as BlackListResponse,
  openDialog: false,
  filters: {pageSize: 10, page: 0},
  isLoading: false,
} as BlackListStateModel;

const blackListSlice = createSlice({
  name: 'black-list',
  initialState: initialState,
  reducers: {
    setFilters(state, action: PayloadAction<BlackListRequest>) {
      state.filters = action.payload;
    },
    setSelectedEntry: (state, action) => {
      state.entry = action.payload;
    },
    openDialog: (state) => {
      state.openDialog = true;
    },
    closeDialog: (state) => {
      state.openDialog = false;
      state.entry = undefined;
    },
    setLocation: (state, action: PayloadAction<string>) => {
      state.filters.locationUuidFilter = action.payload;
    },
    setMainLocation: (state, action: PayloadAction<string>) => {
      state.filters.mainLocationId = action.payload;
    },
    setLoading(state, action) {
        state.isLoading = action.payload;
    },
    },
    extraReducers(builder) {
      builder.addCase(fetchBlackListRows.pending, (state) => {
        state.isLoading = true;
        state.data = {} as BlackListResponse;
      });
      builder.addCase(fetchBlackListRows.fulfilled, (state, action: PayloadAction<BlackListResponse>) => {
        state.data = action.payload;
        state.isLoading = false;
      });
      builder.addCase(fetchBlackListRows.rejected, (state) => {
        state.isLoading = false;
      });
      builder.addCase(deleteBlackList.fulfilled, (state, action: PayloadAction<string>) => {
        const index = state.data.content.findIndex((x) => x.uuid == action.payload);
        state.data.content.splice(index, 1);
      });
      builder
        .addCase(exportData.pending, (state) => {
          state.isLoading = true;
        })
        .addCase(exportData.fulfilled, (state) => {
          state.isLoading = false;
        })
        .addCase(exportData.rejected, (state) => {
          state.isLoading = false;
        });
    },
});

export const {setFilters, setSelectedEntry, openDialog, closeDialog, setLocation, setMainLocation, setLoading} = blackListSlice.actions;

export default blackListSlice.reducer;
